import React, { useEffect, useState, useRef } from "react";
import './NavbarMob.css';
import { SearchButton, NotificationButton } from '../../UI-comp/ActionButtons';
import logo from '../../../assets/images/Kleido.png';
import ProductList from "./ProductDropDown.js";
import GlobalSearch from "../GlobalSearch/GlobalSearch.js";
import NotificationDropdown from './NotificationDropdown';
import { useNavigate } from 'react-router-dom';
import { useUserData } from "../../../hooks/useUserData.js";

const NavbarMob = () => {
  const navigate = useNavigate();
  const [userid, setUserid] = useState(null);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const [showNotificationDropdown, setShowNotificationDropdown] = useState(false);
  const [showMenuPopup, setShowMenuPopup] = useState(false);
  const [showOptionsPopup, setShowOptionsPopup] = useState(false);
  
  const dropdownRef = useRef(null);
  const menuRef = useRef(null);
  const optionsRef = useRef(null);

  // Fetch userid from localStorage on component mount
  useEffect(() => {
    try {
      const userLoggedIn = localStorage.getItem('userLoggedin');
      if (userLoggedIn) {
        const parsedUser = JSON.parse(userLoggedIn);
        const id = parsedUser.userid || parsedUser.id || parsedUser.userId;
        if (id) {
          setUserid(id);
        }
      }
    } catch (error) {
      console.error('Error fetching userid from localStorage:', error);
    }
  }, []);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowSearchDropdown(false);
      }
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenuPopup(false);
        setShowOptionsPopup(false);
      }
      if (optionsRef.current && !optionsRef.current.contains(event.target) && 
          menuRef.current && !menuRef.current.contains(event.target)) {
        setShowOptionsPopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const { userData, loading, error } = useUserData();

  if (loading) {
    return (
      <nav className="ap-Navbar-container">
        <div className="navbar-loading">Loading user data...</div>
      </nav>
    );
  }

  if (error) {
    return (
      <nav className="ap-Navbar-container">
        <div className="navbar-error">Error loading user data: {error}</div>
      </nav>
    );
  }

  const handleLogoClick = () => {
    navigate(`/user-feed/${userid || 'sample'}`);
  };

  const toggleNotificationDropdown = () => {
    setShowNotificationDropdown((prev) => !prev);
    setShowSearchDropdown(false);
    setShowMenuPopup(false);
  };

  const toggleSearchDropdown = () => {
    setShowSearchDropdown((prev) => !prev);
    setShowNotificationDropdown(false);
    setShowMenuPopup(false);
  };

  const toggleMenuPopup = () => {
    setShowMenuPopup((prev) => !prev);
    setShowOptionsPopup(false);
    setShowSearchDropdown(false);
    setShowNotificationDropdown(false);
  };

  const handleMenuItemClick = (item) => {
    if (item === 'Options') {
      setShowOptionsPopup(true);
    } else {
      // Navigate to respective pages
      const routes = {
        'Home': `/user-feed/${userid || 'sample'}`,
        'Friends': '/friends',
        'Groups': '/groups',
        'Reels': '/reels',
        'Trend': '/trend',
        'Instants': '/instants',
        'Community': '/community',
        'Profile': `/profile/${userid || 'sample'}`
      };
      if (routes[item]) {
        navigate(routes[item]);
        setShowMenuPopup(false);
      }
    }
  };

  const handleOptionsItemClick = (item) => {
    const routes = {
      'Post': '/post',
      'Shared': '/shared',
      'Suggested': '/suggested',
      'Saved': '/saved',
      'Archived': '/archived',
      'Explore': '/explore',
      'Settings': '/settings',
      'Logout': '/logout'
    };
    
    if (item === 'Logout') {
      localStorage.removeItem('userLoggedin');
      navigate('/login');
    } else if (routes[item]) {
      navigate(routes[item]);
    }
    
    setShowOptionsPopup(false);
    setShowMenuPopup(false);
  };

  console.log("master User Data: ", userData);
  console.log("Current User ID: ", userid);

  return (
    <div className="ap-Navbar-container">
      {/* Left Segment - 20% */}
      <div className="navbar-left-segment">
        <div className="navbar-app-logo-container">
          <img
            src={logo}
            alt="App Logo"
            className="app-logo"
            onClick={handleLogoClick}
          />
        </div>
      </div>

      {/* Right Segment - 80% */}
      <div className="navbar-right-segment">
        <div className="navbar-action-buttons">
          <div onClick={toggleSearchDropdown} className="navbar-icon-btn">
            <SearchButton />
          </div>

          <div onClick={toggleNotificationDropdown} className="navbar-icon-btn">
            <NotificationButton />
          </div>

          <div className="navbar-products" style={{marginBottom: 25}}>
            <ProductList
              isDeluzon={userData?.isDeluzonSet ?? false}
              isOotshav={userData?.isOotshavSet ?? false}
              isKlamity={userData?.isKlamitySet ?? false}
            />
          </div>

          {/* Three-bar Menu Icon */}
          <div onClick={toggleMenuPopup} className="navbar-menu-icon" ref={menuRef}>
            <div className="menu-bar"></div>
            <div className="menu-bar"></div>
            <div className="menu-bar"></div>
          </div>
        </div>
      </div>

      {/* Search Dropdown */}
      {showSearchDropdown && (
        <div className="nb-search-dropdown" ref={dropdownRef}>
          <GlobalSearch />
        </div>
      )}

      {/* Notification Dropdown */}
      {showNotificationDropdown && (
        <NotificationDropdown onClose={() => setShowNotificationDropdown(false)} />
      )}

      {/* Main Menu Popup */}
      {showMenuPopup && (
        <div className="navbar-menu-popup">
          <div className="menu-popup-item" onClick={() => handleMenuItemClick('Home')}>
            Home
          </div>
          <div className="menu-popup-item" onClick={() => handleMenuItemClick('Friends')}>
            Friends
          </div>
          <div className="menu-popup-item" onClick={() => handleMenuItemClick('Groups')}>
            Groups
          </div>
          <div className="menu-popup-item" onClick={() => handleMenuItemClick('Reels')}>
            Reels
          </div>
          <div className="menu-popup-item" onClick={() => handleMenuItemClick('Trend')}>
            Trend
          </div>
          <div className="menu-popup-item" onClick={() => handleMenuItemClick('Instants')}>
            Instants
          </div>
          <div className="menu-popup-item" onClick={() => handleMenuItemClick('Community')}>
            Community
          </div>
          <div className="menu-popup-item" onClick={() => handleMenuItemClick('Profile')}>
            Profile
          </div>
          <div className="menu-popup-item" onClick={() => handleMenuItemClick('Options')}>
            Options →
          </div>
        </div>
      )}

      {/* Options Sub-Popup */}
      {showOptionsPopup && (
        <div className="navbar-options-popup" ref={optionsRef}>
          <div className="menu-popup-item" onClick={() => handleOptionsItemClick('Post')}>
            Post
          </div>
          <div className="menu-popup-item" onClick={() => handleOptionsItemClick('Shared')}>
            Shared
          </div>
          <div className="menu-popup-item" onClick={() => handleOptionsItemClick('Suggested')}>
            Suggested
          </div>
          <div className="menu-popup-item" onClick={() => handleOptionsItemClick('Saved')}>
            Saved
          </div>
          <div className="menu-popup-item" onClick={() => handleOptionsItemClick('Archived')}>
            Archived
          </div>
          <div className="menu-popup-item" onClick={() => handleOptionsItemClick('Explore')}>
            Explore
          </div>
          <div className="menu-popup-item" onClick={() => handleOptionsItemClick('Settings')}>
            Settings
          </div>
          <div className="menu-popup-item menu-logout" onClick={() => handleOptionsItemClick('Logout')}>
            Logout
          </div>
        </div>
      )}
    </div>
  );
};

export default NavbarMob;
